// UserRole lives here (a leaf constants module) rather than in authHelper to
// avoid a circular import: authHelper imports isAuthGuardActive from this file,
// so authHelper cannot also be the source of UserRole without a load-order TDZ.
export const UserRole = {
  Admin: 0,
  Editor: 1,
};

/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';

// Keep item-menu (sub-menu) always visible
// Set to false to allow collapsing behavior
export const alwaysShowItemMenu = true;

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;

// Cognito configuration is loaded from environment variables
// See: frontend/.env.example for documentation

export const adminRoot = '/app';
export const buyUrl = 'https://1.envato.market/k4z0';
export const searchPath = `${adminRoot}/#`;
export const servicePath = 'https://api.coloredstrategies.com';

export const currentUser = {
  id: 1,
  title: 'Sarah Kortney',
  img: '/assets/img/profiles/l-1.jpg',
  date: 'Last seen today 15:24',
  role: UserRole.Admin
}


export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = true;
export const defaultColor = 'light.purplemonster';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
];
